module.exports = __webpack_public_path__ + "static/media/monedas-banner.aaa5b6d0.svg";